<template>
  <div class="phoneBottom" >
    <van-tabbar
      v-model="active"
      :route="isRouteMode"
      :color="textColor"
      :active-color="activeTextColor"
      :border="showBorder"
      class="bgcolor"
      @change="handleTabChange"
    >
      <van-tabbar-item
        :icon="item.icon"
        v-for="(item, index) in tabList"
        :key="index"
        :name="item.key"
        >{{ item.text }}
        {{ item.icon }}</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "phoneBottom",
  props: {
    /** 导航菜单配置 */
    tabList: {
      type: Array,
      required: true,
      default: () => [],
    },
    /** 是否路由模式（点击跳转路由） */
    isRouteMode: {
      type: Boolean,
      default: false,
    },
    /** 初始激活键 */
    defaultActiveKey: {
      type: [String, Number],
      default: "",
    },
    /** 文本颜色 */
    textColor: {
      type: String,
      default: "#646566",
    },
    /** 激活文本颜色 */
    activeTextColor: {
      type: String,
      default: "#1989fa",
    },
    /** 背景颜色 */
    bgColor: {
      type: String,
      default: "#868686"
    },
    /** 导航栏高度 */
    tabbarHeight: {
      type: [String, Number],
      default: 50,
    },
    /** 图标大小 */
    iconSize: {
      type: [String, Number],
      default: 22,
    },
    /** 是否显示上边框 */
    showBorder: {
      type: Boolean,
      default: true,
    },
    
  },
  data() {
    return {
      active: 0,
    };
  },
  created() {
    console.log('底部导航栏子组件挂载了--111--1-233-21-11', this.tabList)
  },
   methods: {
    // 切换回调
    handleTabChange(key) {
      this.activeKey = key;
       const currentItem = this.tabList.find(item => item.key === key);
      console.log('底部导航栏点击跳转了', currentItem)
      if (currentItem) {
        this.$emit('change', currentItem, key);
      }
    },
    // 凸起项点击回调（额外触发）
    handleRaiseItemClick(item) {
      this.$emit('raise-item-click', item);
    }
  }
};
</script>

<style lang="scss" scoped>
// 底部tabbar固定在底部 覆盖原有样式
::v-deep.van-tabbar--fixed {
  position: relative;
}
::v-deep .bgcolor {
  .van-tabbar-item {
    background-color: v-bind(bgColor);
  }
}

.phoneBottom {
  width: 100%;
  background-color: #a31f1f;
  min-height: 50px;
  cursor: pointer;
  // padding-top: 30px;
  box-sizing: border-box;
}
</style>
